import { get, post } from "./request";

/**
 * 订阅管理接口（API 文档第 4 节 /console/subscription）。
 */

// ---------- 类型 ----------

/** GET /subscription/current */
export interface CurrentSubscription {
  planCode: string;
  planName: string;
  monthlyFeeCents: number;
  monthlyCreditsCents: number;
  status: string;
  periodStart: string;
  periodEnd: string;
  pendingPlanCode: string;
  monthlyCreditBalance: number;
  purchasedCreditBalance: number;
}

/** 单个 API 的计费单价（美分/次） */
export interface ApiPricing {
  apiCode: string;
  priceCents: number;
}

/** GET /subscription/plans 单项 */
export interface Plan {
  planCode: string;
  planName: string;
  monthlyFeeCents: number;
  monthlyCreditsCents: number;
  maxApiKeys: number;
  rateLimitQps: number;
  isRechargeable: boolean;
  apiPricing: ApiPricing[];
}

// ---------- 接口 ----------

export function getCurrentSubscription(): Promise<CurrentSubscription> {
  return get<CurrentSubscription>("/subscription/current");
}

export function getPlans(): Promise<Plan[]> {
  return get<Plan[]>("/subscription/plans");
}

/** POST /subscription/upgrade 的返回（多种状态） */
export interface UpgradeResult {
  message?: string;
  planCode?: string;
  status?: "requires_action" | "requires_payment_method";
  clientSecret?: string;
  subscriptionId?: string;
}

/** POST /subscription/upgrade */
export function upgradeSubscription(
  paymentMethodId: string
): Promise<UpgradeResult> {
  return post<UpgradeResult>("/subscription/upgrade", { paymentMethodId });
}

/** POST /subscription/downgrade 的返回 */
export interface DowngradeResult {
  message: string;
  effectiveDate: string;
}

/** POST /subscription/downgrade（无请求体） */
export function downgradeSubscription(): Promise<DowngradeResult> {
  return post<DowngradeResult>("/subscription/downgrade");
}
